import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TripleListComponent } from './triple-list.component';

@NgModule({
  imports: [
    CommonModule
 ],
  exports: [
    TripleListComponent
  ],
  declarations: [
    TripleListComponent
  ],
})
export class TripleListModule { }
